(() => {
  function initialize(root) {
    if (root.dataset.contactReady) return;
    root.dataset.contactReady = 'true';
    const form = root.querySelector('form');
    const reason = root.querySelector('[data-contact-reason]');
    const order = root.querySelector('[data-contact-order]');
    const orderInput = root.querySelector('[data-order-input]');
    const orderLabel = root.querySelector('[data-order-label]');
    const product = root.querySelector('[data-contact-product]');
    const orderReasons = new Set(['order_status','cancel_order','returns','missing_order','damaged_order']);
    const photoReasons = new Set(['returns','product_issue','damaged_order']);
    const updateReason = () => {
      const needsOrder = orderReasons.has(reason.value);
      const productIssue = reason.value === 'product_issue';
      order.hidden = !needsOrder && !productIssue;
      orderInput.disabled = order.hidden;
      orderInput.required = needsOrder;
      orderLabel.textContent = needsOrder ? orderLabel.dataset.requiredLabel : orderLabel.dataset.optionalLabel;
      product.hidden = !productIssue;
      product.querySelectorAll('input').forEach(input => { input.disabled = !productIssue; });
      root.querySelectorAll('[data-contact-note]').forEach(note => { note.hidden = note.dataset.contactNote !== reason.value; });
      photoArea.hidden = !photoReasons.has(reason.value);
      fileInput.disabled = busy || photoArea.hidden;
      links.disabled = photoArea.hidden || !prepared;
    };
    const requestedReason = new URLSearchParams(location.search).get('reason');
    if ([...reason.options].some(option => option.value === requestedReason)) reason.value = requestedReason;
    reason.addEventListener('change', updateReason);
    const messages = JSON.parse(root.querySelector('[data-contact-messages]').textContent);
    const photoArea = root.querySelector('[data-photo-area]');
    const fileInput = root.querySelector('[data-photo-input]');
    const drop = root.querySelector('[data-photo-drop]');
    const list = root.querySelector('[data-photo-list]');
    const status = root.querySelector('[data-photo-status]');
    const error = root.querySelector('[data-photo-error]');
    const links = root.querySelector('[data-photo-links]');
    const button = root.querySelector('[data-contact-submit]');
    const endpoint = root.dataset.uploadService.replace(/\/$/, '');
    const allowedTypes = new Set(['image/jpeg','image/png','image/webp','image/gif','image/avif','image/heic','image/heif']);
    const limit = 50 * 1024 * 1024;
    let photos = [], busy = false, prepared = false;
    updateReason();
    const showError = text => { error.textContent = text; error.hidden = !text; };
    function render() {
      if (!prepared) { links.disabled = true; links.value = ''; }
      list.replaceChildren();
      photos.forEach((photo,index) => {
        const item = document.createElement('li'); item.className = 'skn-contact-page__photo';
        const image = document.createElement('img'); image.src = photo.preview; image.alt = photo.file.name;
        image.addEventListener('error', () => { image.hidden = true; }, {once:true});
        const name = document.createElement('p'); name.className = 'skn-contact-page__photo-name'; name.textContent = photo.file.name;
        const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'skn-contact-page__photo-remove'; remove.textContent = '×';
        remove.setAttribute('aria-label', `${messages.remove} ${photo.file.name}`); remove.disabled = busy;
        remove.addEventListener('click', event => { event.stopPropagation(); URL.revokeObjectURL(photo.preview); photos.splice(index,1); prepared = false; showError(''); render(); });
        item.append(image,name,remove); list.append(item);
      });
      status.textContent = photos.length ? `${photos.length}/10 · ${(photos.reduce((total,p) => total+p.file.size,0)/1024/1024).toFixed(1)} MB` : '';
    }
    function addFiles(files) {
      if (busy || photoArea.hidden) return;
      showError('');
      const incoming = [...files].filter(file => !photos.some(p => p.file.name === file.name && p.file.size === file.size && p.file.lastModified === file.lastModified));
      if (incoming.some(file => !allowedTypes.has(file.type) && !/\.heic$|\.heif$/i.test(file.name))) { showError(messages.invalid); return; }
      if (photos.length + incoming.length > 10 || photos.reduce((n,p) => n+p.file.size,0)+incoming.reduce((n,f) => n+f.size,0) >= limit) { showError(messages.limit); return; }
      incoming.forEach(file => photos.push({file,preview:URL.createObjectURL(file),uploaded:null}));
      prepared = false; render();
    }
    drop.addEventListener('click', () => { if (!busy) fileInput.click(); });
    drop.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); if (!busy) fileInput.click(); } });
    fileInput.addEventListener('change', () => { addFiles(fileInput.files); fileInput.value = ''; });
    ['dragenter','dragover'].forEach(type => drop.addEventListener(type, event => { event.preventDefault(); if (!busy) drop.classList.add('is-dragover'); }));
    ['dragleave','drop'].forEach(type => drop.addEventListener(type, event => { event.preventDefault(); drop.classList.remove('is-dragover'); }));
    drop.addEventListener('drop', event => addFiles(event.dataTransfer.files));
    form.addEventListener('paste', event => { if (!photoArea.hidden && event.clipboardData.files.length) { event.preventDefault(); addFiles(event.clipboardData.files); } });
    async function request(path, options) {
      const controller = new AbortController(); const timeout = setTimeout(() => controller.abort(), 90000);
      try {
        const response = await fetch(endpoint + path, {...options,signal:controller.signal,credentials:'omit'});
        if (!response.ok) throw new Error('Upload failed');
        return await response.json();
      } finally { clearTimeout(timeout); }
    }
    form.addEventListener('submit', async event => {
      if (!photoReasons.has(reason.value)) { links.disabled = true; return; }
      if (prepared || !photos.length) return;
      event.preventDefault(); if (busy) return;
      if (!endpoint) { showError(messages.failure); return; }
      busy = true; button.disabled = true; fileInput.disabled = true; reason.disabled = true; showError('');
      list.querySelectorAll('button').forEach(b => { b.disabled = true; });
      status.textContent = messages.uploading;
      try {
        const pending = photos.filter(photo => !photo.uploaded);
        if (pending.length) {
          const session = await request('/api/session', {method:'POST'});
          for (const photo of pending) {
            const result = await request('/api/uploads', {method:'POST',headers:{Authorization:`Bearer ${session.token}`,'Content-Type':photo.file.type || 'application/octet-stream','X-File-Name':encodeURIComponent(photo.file.name)},body:photo.file});
            const photoUrl = new URL(result.url);
            if (photoUrl.origin !== new URL(endpoint).origin || photoUrl.protocol !== 'https:') throw new Error('Invalid photo URL');
            photo.uploaded = {url:photoUrl.href,name:photo.file.name};
          }
        }
        links.value = photos.map(photo => `${photo.uploaded.name}: ${photo.uploaded.url}`).join('\n');
        links.disabled = false; prepared = true; busy = false; button.disabled = false; fileInput.disabled = false; reason.disabled = false;
        status.textContent = messages.ready;
        form.requestSubmit(button);
      } catch {
        busy = false; button.disabled = false; fileInput.disabled = false; reason.disabled = false; render(); showError(messages.failure);
      }
    });
  }
  const start = () => document.querySelectorAll('[data-skn-contact]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  document.addEventListener('shopify:section:load',start);
})();
